export const HamburgerMenuHeader = () => {
  return (
    <svg
      className="block w-8 h-8"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M3 8C3 7.448 3.448 7 4 7H28C28.552 7 29 7.448 29 8C29 8.552 28.552 9 28 9H4C3.448 9 3 8.552 3 8ZM28 15H4C3.448 15 3 15.448 3 16C3 16.552 3.448 17 4 17H28C28.552 17 29 16.552 29 16C29 15.448 28.552 15 28 15ZM28 23H4C3.448 23 3 23.448 3 24C3 24.552 3.448 25 4 25H28C28.552 25 29 24.552 29 24C29 23.448 28.552 23 28 23Z"
        fill="#0A0A0A"
      ></path>
    </svg>
  )
}
